import React from "react";

const Aboutus = () => {
    return (
        <>
            <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row align-items-center text-center">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title">About Us</h2>
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">

                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="booking-section">
                <div className="container">

                    <div className="tab-content" id="pills-tabContent">
                        <div className="tab-pane fade show active" id="pills-booking" role="tabpanel" aria-labelledby="pills-booking-tab">
                           
                                <div className="booking-title">
                                    <h3>About us</h3>
                                </div>
                                <div>
                                Welcome to Triloki Cabs, your premier choice for reliable and comfortable transportation services. We take pride in providing exceptional taxi services that prioritize safety, convenience, and customer satisfaction. At Triloki Cabs, we understand the importance of a trustworthy and efficient transportation solution. Whether you need a ride to the airport, a business meeting, or a leisurely outing, our professional drivers are dedicated to delivering a seamless and enjoyable.
<br/><br/><div>Triloki Cabs, a Bihar-based service establishment,  Triloki Cabs is dedicated to providing customers with top-notch and affordable car rental services while adhering to best industry practices.</div>
<br/><br/><div>If you need a taxi to travel within Bihar, count on Triloki Cabs service. We are a one-stop shop for booking online cab services to commute on Bihar’s roads. From standard cab services to car rental solutions, Triloki Cabs provides a wide selection of reasonably priced cabs with professional drivers for one-way and round-trip journeys.</div>
<br/><br/><div>We offer local cabs for a full/half day travel around the city and transfers to and from airports/stations. In addition, we provide rental car service and outstation cab service for intercity tours. You can book a cab from Triloki Cabs as per your needs from an array of vehicles, including hatchbacks and sedans to SUVs and MUVs. Our motorcycles and E-rickshaws make navigating the congested streets of Bihar a breeze.</div>
<br/><br/><div>At Triloki Cabs, we tailor our fleet to suit your needs to deliver the most cost-effective and pleasurable transportation possible. Book a cab with us through our website and phone call.</div>
                                </div>
                              
                            </div>

                        

                    </div>
                </div>
            </section>



        </>
    )
}

export default Aboutus;